import React from 'react';
import { cn } from '@/lib/utils';

type Severity = 'High' | 'Medium' | 'Low' | 'Success' | 'Attention';

interface SeverityBadgeProps {
  severity: Severity;
  children: React.ReactNode;
  className?: string;
}

/**
 * SeverityBadge - Status/severity indicator.
 * Canonical location: blocks/SeverityBadge. Re-exported from ui/SeverityBadge for backward compatibility.
 */
export const SeverityBadge: React.FC<SeverityBadgeProps> = ({
  severity,
  children,
  className,
}) => {
  const severityStyles: Record<Severity, string> = {
    High: 'bg-destructive/20 text-destructive border border-destructive/30',
    Medium: 'bg-amber-500/20 text-amber-600 dark:text-amber-400 border border-amber-500/30',
    Low: 'bg-muted text-muted-foreground border border-border',
    Success: 'bg-primary/20 text-primary border border-primary/30',
    Attention: 'bg-destructive/20 text-destructive border border-destructive/30',
  };

  return (
    <span
      className={cn(
        'text-[10px] px-2 py-0.5 rounded inline-block',
        severityStyles[severity],
        className
      )}
    >
      {children}
    </span>
  );
};
